export class AddOrRemoveWhitelistedUserResponseModel {
    constructor(
        public customerUuid: string,
        public message: string,
        public action: string,
    ) {}
}
